export const ENTITLEMENT_STATUS = {
  ENABLED: 1,
  RETURNED: 2,
  EXPIRED: 3,
  INACTIVE: 4,
  HOTLIST: 5,
  DEFERRED: 6,
  SHARED: 7,
};

export enum ENTITLEMENT_CATEGORY_ID {
  LIFT = 1,
  FNF_SHARED_VOUCHER = 2,
}

export const RELEVANT_STATUSES = [
  ENTITLEMENT_STATUS.ENABLED,
  ENTITLEMENT_STATUS.DEFERRED,
];
